<template>
  <div data-locator="duplicate-content">
    <v-row no-gutters>
      <div class="text-subtitle-1 text-text-primary">
        <b>{{$t('project.documents.pane.DocumentsPaneDuplicate.duplicateTo')}}</b>
      </div>
    </v-row>
    <v-row no-gutters class="mt-4">
      <AppClosdFildersTree
        v-model:value="selectedFolder"
        :root-folder="documentsTree"
        folders-only
        style="width: 100%;"
        :multiple="false"
        :default-expand="false"
      />
      <AppClosdFildersTree
        v-if="todoDocumentsTree"
        v-model:value="selectedFolder"
        :root-folder="todoDocumentsTree"
        folders-only
        style="width: 100%;"
        :multiple="false"
        :default-expand="false"
      />
    </v-row>
  </div>
</template>
<script>
import { reactive } from 'vue'
import { mapActions, mapState } from 'vuex'

import AppClosdFildersTree from '@/common/app-closd-filders-tree/AppClosdFildersTree.vue'
import { toast } from '@/common/utils/toast'
import { CLOSE_TABLE_DOCUMENTS_PANE, DUPLICATE_FILDERS } from '@/store/modules/documents/action_types'

export default {
  name: 'DocumentsPaneDuplicate',
  components: { AppClosdFildersTree },
  emits: ['update:submit-disabled'],
  data () {
    return {
      selectedFolder: [],
    }
  },
  computed: {
    ...mapState('documents', ['documents', 'duplicateLoading', 'documentsTablePane', 'foldersTree']),
    isDuplicateDisabled () {
      return this.documentsTablePane.documents.length === 0 || !this.isSelectedFolderValid
    },
    isSelectedFolderValid () {
      return this.selectedFolder.length !== 0 &&
          this.selectedFolder[0]?.specialFolder !== 'todo' &&
          this.selectedFolder[0]?.specialFolder !== 'qa' &&
          this.documentsTablePane.documents.every(doc => doc.type !== 'folder')
    },
    documentsTree () {
      const qaFolderId = this.foldersTree.qaFolderId

      return {
        id: 0,
        type: 'folder',
        name: this.$t('common.documents.rootFolder'),
        basename: this.$t('common.documents.rootFolder'),
        children: this.foldersTree.folders
          .filter(folder => folder.id !== qaFolderId)
          .map(folder => ({
            ...folder,
            basename: folder.name,
            childrenCount: folder.hasFolderChildren ? 1 : 0,
            type: 'folder',
          })),
      }
    },
    todoDocumentsTree () {
      if (this.foldersTree.todoFolderId === null || !this.foldersTree.hasAccessToTodoFolder) {
        return false
      }

      // Here using "reactive" is necessary because the AppClosdFildersTree component applies changes to the "children"
      // field of its "rootFolder" prop, and some computed properties depend on it (It's a bad practice but we prefer
      // to not change a common component so we make a change here)
      return reactive({
        id: this.foldersTree.todoFolderId,
        type: 'folder',
        name: this.$t('common.documents.todoFolder'),
        basename: this.$t('common.documents.todoFolder'),
        children: [],
        childrenCount: 1,
        specialFolder: 'todo',
      })
    },
  },
  watch: {
    // The confirm action now sits in the drawer footer, outside of the scrollable body, so the
    // pane that renders it has to be told when this form becomes submittable.
    isDuplicateDisabled: {
      handler (disabled) {
        this.$emit('update:submit-disabled', disabled)
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('documents', [CLOSE_TABLE_DOCUMENTS_PANE, DUPLICATE_FILDERS]),
    async duplicate () {
      try {
        await this.DUPLICATE_FILDERS({
          documents: this.documentsTablePane.documents,
          targetFolderId: this.selectedFolder[0].id,
        })
        this.close()
        toast.success(this.$t('project.documents.pane.DocumentsPaneDuplicate.successMessage'))
      } catch {
        toast.error(this.$t('project.documents.pane.DocumentsPaneDuplicate.errorMessage'))
      }
    },
    close () {
      this.CLOSE_TABLE_DOCUMENTS_PANE()
      this.selectedFolder = []
    },
  },
}
</script>
